<template>
  <v-container fluid tag="section" class="pb-0" v-if="data">
    <v-row>
      <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        客户名称：<span class="font-weight-black">{{data.name}}</span>
        ({{data.createTime | formatDay}})
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        客户类型：<span class="font-weight-black">{{data.typeDic === null || data.typeDic === undefined  ? '' : data.typeDic.name}}</span>
      </v-col>
       <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
        客户来源：<span class="font-weight-black">{{data.fromDic === null || data.fromDic === undefined ? '' : data.fromDic.name}}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        客户阶段：<span class="font-weight-black">{{data.stageDic === null || data.stageDic === undefined ? '' : data.stageDic.name}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        客户行业：<span class="font-weight-black">{{data.tradeDic === null || data.tradeDic === undefined ? '' : data.tradeDic.name}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        客户分级：<span class="font-weight-black">{{data.gradeDic === null || data.gradeDic === undefined ? '' : data.gradeDic.name}}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        <strong v-if="!$isMobile">客户地址：</strong><span class="font-weight-black">{{data.contactsAddress}}</span>
      </v-col>
    </v-row>
    <div v-if="data.detail">
      <v-divider class="my-4 mb-4"></v-divider>
      <v-row>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          成立年度：<span class="font-weight-black">{{data.detail === null  ? '' : data.detail.createYear}}年</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          知识产权：<span class="font-weight-black">{{data.detail === null  ? '' : data.detail.patentNumber}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          员工数量：<span class="font-weight-black">{{data.detail === null  ? '' : data.detail.workers}}</span>
        </v-col>
      </v-row>
      <v-row>
      <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        企业资质：
        <v-chip small color="primary" variant="outlined" class="mr-2" v-if="data.detail !== null" label :key="idx" v-for="(i, idx) in data.detail.seniorityList">
          {{ `[${i.startYear}] ${i.seniorityDic.title}` }}
        </v-chip>
      </v-col>
    </v-row>
    </div>
    <v-divider class="mt-4"></v-divider>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="30"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
  import { getById } from '@/api/customer/index.js'

  export default {
    name: 'CustomerDetail',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      lazy: {
        type: Boolean,
        default: false
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        data: this.item
      }
    },
    methods: {
      loadData () {
        if (this.item && this.item.id) {
          this.loading = true
          getById(this.item.id).then(res => {
            if (res.status === 200) {
              this.data = res.data
            }
            this.loading = false
          })
        }
      }
    },
    created () {
      if (this.lazy) {
        this.loadData()
      }
    }
  }
</script>

<style>
</style>
